import GenericTopPostsDrawer from './GenericTopPostsDrawer';
import React from 'react';
import { getBrandOnlyRelatedHashtagTopPosts } from 'utils/api/instagram.api';

const RelatedHashtagBrandOnly = ({
    year,
    week,
    brands,
    hashtags,
    countries,
    name,
    displayQty,
}) => {
    const queryParams = {
        brand: brands || null,
        hashtag: hashtags || null,
        country: countries || null,
        page: 1,
        per_page: 500,
    };

    return (
        <GenericTopPostsDrawer
            year={year}
            week={week}
            name={name}
            displayQty={displayQty}
            queryFn={getBrandOnlyRelatedHashtagTopPosts}
            queryParams={queryParams}
        />
    );
};

export default RelatedHashtagBrandOnly;
